export default "__VITE_ASSET__BHUg2Fzg__"